export const donViTinh = {
  sections: {
    list: { title: '计量单位' },
    detail: { title: '计量单位' },
  },
  titles: { add: '新增单位', edit: '编辑单位', create: '创建单位' },
  columns: {
    code: '编码',
    summary: '单位名称',
    note: '备注',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    status: '状态',
    onOffAction: '启停',
  },
  filter: {
    searchPlaceholder: '按编码或名称搜索...',
    textDetailTitle: '详细筛选',
  },
  filters: {
    hintSection: '提示',
    hintBody: '商品使用的计量单位目录。',
    statusAll: '全部',
  },
  status: {
    dangHoatDong: '启用',
    ngungHoatDong: '停用',
  },
  actions: {
    pause: '停用',
    activate: '启用',
  },
  messages: {
    loadError: '无法加载单位列表。',
    deleteSuccess: '已删除单位。',
    noData: '暂无单位。',
    listSummary: '共 {count} 条',
    saveSuccess: '已保存单位。',
    createSuccess: '创建单位成功',
    statusChanged: '状态已更新。',
    selectedCount: '已选 {count} 项',
    deleteSelected: '删除所选 ({count})',
    bulkDeleteConfirm: '确定删除所选的 {count} 个单位？',
    bulkDeleteSuccess: '已删除 {count} 个单位',
    bulkDeletePartial: '已删除 {ok}/{total}，{failed} 项失败。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '请先选择要删除的单位',
  },
  form: {
    tenDonViTinh: '单位名称',
    maDonViTinh: '编码（可选）',
    ghiChu: '备注',
  },
  validation: {
    tenRequired: '请输入单位名称。',
  },
  import: {
    description:
      'Excel 文件包含 3 列：单位编码（可选）、单位名称（必填）、备注（可选）。编码留空将自动生成；已有编码将更新。',
    success: '已从 Excel 导入计量单位。',
    failed: '从 Excel 导入计量单位失败。',
    empty: 'Excel 文件没有有效数据行。',
  },
  placeholders: {
    formTitle: '计量单位',
    formBody: '',
    tenDonViTinh: '请输入单位名称',
  },
}
